import { render } from "./LogoIcon.vue?vue&type=template&id=800b811c&scoped=true&ts=true"
import script from "./LogoIcon.vue?vue&type=script&lang=ts"
export * from "./LogoIcon.vue?vue&type=script&lang=ts"

import "./LogoIcon.vue?vue&type=style&index=0&id=800b811c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800b811c"]])

export default __exports__